import dayjs from 'dayjs';

import { useAppSelector } from '@verantos-dev/core-annotation-tool';

import { useGetIRRScoreCardsDataQuery } from '../../api/metricsApiSlice';
import {
  selectIRRCardFilters,
  selectIRRFilterTypeId,
  selectIRRScoreBatchTypeId,
  selectIRRScoreDate,
  selectSelectedProjectId,
} from '../../state/selector';
import { IRRScoreCardData } from '../../types/responseTypes';

interface UseIRRScoreCardsResults {
  irrScoreCardsData: IRRScoreCardData | null;
  isIRRScoreCardsDataLoading: boolean;
}

export const useIRRScoreCards = (): UseIRRScoreCardsResults => {
  const selectedProjectId = useAppSelector(selectSelectedProjectId);
  const batchTypeId = useAppSelector(selectIRRScoreBatchTypeId);
  const date = useAppSelector(selectIRRScoreDate);
  const filterTypeId = useAppSelector(selectIRRFilterTypeId);
  const cardFilters = useAppSelector(selectIRRCardFilters);

  const {
    data: irrScoreCardsData,
    isLoading: isIRRScoreCardsDataLoading,
    isFetching: isIRRScoreCardsDataFetching,
  } = useGetIRRScoreCardsDataQuery(
    {
      batchTypeId: batchTypeId || '',
      projectId: selectedProjectId || '',
      filterTypeId: filterTypeId || '',
      date: date ? dayjs(date).format('YYYY-MM-DD') : undefined,
      annotator1: cardFilters?.annotator1 ?? undefined,
      annotator2: cardFilters?.annotator2 ?? undefined,
      conceptIds: cardFilters?.conceptIds ?? undefined,
      entityIds: cardFilters?.entityIds ?? undefined,
    },
    { skip: !(selectedProjectId && batchTypeId) }
  );
  return {
    irrScoreCardsData: irrScoreCardsData?.data || null,
    isIRRScoreCardsDataLoading: isIRRScoreCardsDataFetching || isIRRScoreCardsDataLoading,
  };
};
